import { z } from "zod";

export const tradeInVehicleSchema = z.object({
  brandId: z.number(),
  model: z.string().trim().min(1),
});

export const vehicleTradeInPayloadSchema = z.discriminatedUnion("hasTradeIn", [
  z.object({
    hasTradeIn: z.literal(false),
  }),
  z.object({
    hasTradeIn: z.literal(true),
    tradeInVehicles: z.array(tradeInVehicleSchema).min(1).max(3),
  }),
]);

export type TradeInVehiclePayload = z.infer<typeof tradeInVehicleSchema>;
export type VehicleTradeInPayload = z.infer<typeof vehicleTradeInPayloadSchema>;
